export default __webpack_public_path__ + "static/media/front.551f2be9.svg";